import { format, subHours } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

import theme from '../styles/theme';
import { store } from '../store';

export function formatPrice(value: any): string {
  const { currency } = store.getState().user.user.config;
  if (value || value === 0) {
    if (currency === 'BRL') {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    }
    return new Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
  }
  return value;
}

export function correctPricePtBrToEn(value: any) {
  const value1 = value.replace(',', '.');
  const value2 = value1.replace(',', '.');
  let value3 = value2;
  if (value2.split('.').length - 1 > 1) {
    value3 = value1.replace('.', '');
  }
  return value3;
}

export function setPriceColor(value: Number | string): string {
  if (value > 0) {
    return theme.colors.win;
  }
  if (value < 0) {
    return theme.colors.loss;
  }
  return '#fff';
}

export function setPercentColor(value: Number): string {
  if (value === null) {
    return '#fff';
  }
  if (value < 50) {
    return theme.colors.loss;
  }
  return theme.colors.win;
}

export function dateToTimezone(date: string): string {
  if (date) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const correctDate = utcToZonedTime(date, timezone);
    const formattedDate = format(correctDate, "HH':'mm' 'dd'/'MM'/'yyyy");

    return formattedDate;
  }
  return date;
}

export function hourToTimezone(hour: any): any {
  const timeZoneDate = new Date();
  const offsetHours = timeZoneDate.getTimezoneOffset() / 60;
  const date = new Date(2020, 2, 15, hour);
  const parsedDate = subHours(date, offsetHours);

  return parsedDate.getHours();
}

export function correctInstrument(instrument: string): string {
  switch (instrument) {
    case 'Binary Options':
    case 'Opções Binárias':
      return 'Binárias';
    case 'Digital Options':
    case 'Digitais':
      return 'Digitais';
    case 'Forex':
      return 'Forex';
    default:
      return instrument; // Return original value for custom trade types
  }
}

// Stop Win/Loss Modal Helper Functions
export function checkStopWinLoss(
  todayTotal: number,
  stopWin: number,
  stopLoss: number
): { type: 'win' | 'loss' | null } {
  if (stopWin > 0 && todayTotal >= stopWin) {
    return { type: 'win' };
  }

  if (stopLoss > 0 && todayTotal <= -stopLoss) {
    return { type: 'loss' };
  }

  return { type: null };
}

export function shouldShowStopModal(type: 'win' | 'loss'): boolean {
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
  const key = `stopWinLossModal_${type}_${today}`;
  return !localStorage.getItem(key);
}

export function markStopModalShown(type: 'win' | 'loss'): void {
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
  const key = `stopWinLossModal_${type}_${today}`;
  localStorage.setItem(key, 'true');
}

export function phoneMask(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return digits.length ? `(${digits}` : '';
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
